import React from "react";
import { EditAction } from "components/buttons";
import { Restricted, permissions } from "components/auth";
import { DeleteActionWithModal } from "components/buttons";
import { useMutation } from "@apollo/react-hooks";
import PropTypes from "prop-types";

const ActionButtons = ({ id, customerId, name, mutation, history }) => {
  const [deleteContract] = useMutation(mutation);

  return (
    <>
      <Restricted permissions={[permissions.contract_manage]}>
        <EditAction url={`/contract/edit/${id}`} />
        <DeleteActionWithModal
          actionButton
          urlOnSuccess="/contract/list"
          history={history}
          mutation={deleteContract}
          mutationVariables={{
            customerId: customerId,
            contractId: id,
          }}
          elementNameInResult="deleteContract"
          elementToDelete={name}
        />
      </Restricted>
    </>
  );
};

ActionButtons.propTypes = {
  /**
   * Id del elemento sobre el que se realiza la acción
   **/
  id: PropTypes.string,
  /**
   * Id del customer
   **/
  customerId: PropTypes.string,
  /**
   * Nombre del elemento
   **/
  name: PropTypes.string,
  /**
   * Query gql de borrado del elemento
   **/
  mutation: PropTypes.object.isRequired,
};

export default ActionButtons;
